import React from 'react';

import { ContinueButton } from './ContinueButton';

// We don't want navigate to be passed down to Button
// eslint-disable-next-line no-unused-vars, react/prop-types
export const ContinueLink = ({ navigate, ...props }) => (
  <ContinueButton as="a" {...props} />
);
